import React from 'react';
import { Header, Icon } from 'semantic-ui-react';
import ContractLinesEditor, { type ContractLinesEditorProps } from './ContractLinesEditor';

export interface ContractFormLinhasTabProps extends ContractLinesEditorProps {
  children?: React.ReactNode;
}

/**
 * Aba "Linhas do Contrato" do modal de criação/edição.
 * Encapsula o título e o ContractLinesEditor; o formulário de adicionar linha
 * e a LinesList são passados como children pela página.
 */
export const ContractFormLinhasTab: React.FC<ContractFormLinhasTabProps> = ({ children, ...editorProps }) => {
  return (
    <div style={{ padding: '20px' }}>
      <Header as="h3" style={{ color: '#2c3e50', marginBottom: '20px' }}>
        <Icon name="list" />
        Linhas do Contrato
      </Header>

      <p style={{ color: '#666', marginBottom: '20px' }}>
        Configure as linhas telefônicas que serão incluídas no contrato.
      </p>

      <ContractLinesEditor {...editorProps}>{children}</ContractLinesEditor>
    </div>
  );
};
